import { get, post, del, put } from '@api/request';

export const fetchVersions = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID },
) => {
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}/versions/allyears`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createVersion = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID, year, payload },
) => {
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}/versions/${year}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteVersion = async (
  { assessmentService },
  authenticationToken,
  { versionID },
) => {
  const url = `${assessmentService}/assessment/taxingunit/version/${versionID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const updateVersion = async (
  { assessmentService },
  authenticationToken,
  { versionID, payload },
) => {
  const url = `${assessmentService}/assessment/taxingunit/version/${versionID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const activateVersion = async (
  { assessmentService },
  authenticationToken,
  { versionID, payload },
) => {
  const url = `${assessmentService}/assessment/taxingunit/version/${versionID}/activate`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchVersionExemptions = async (
  { assessmentService },
  authenticationToken,
  { versionID },
) => {
  const url = `${assessmentService}/assessment/taxingunit/version/${versionID}/exemptions`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deleteVersionExemption = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitExemptionID },
) => {
  const url = `${assessmentService}/assessment/taxingunitexemption/${taxingUnitExemptionID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const createVersionExemption = async (
  { assessmentService },
  authenticationToken,
  { versionID, payload },
) => {
  const url = `${assessmentService}/assessment/taxingunit/version/${versionID}/exemptions`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateVersionExemption = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitExemptionID, payload },
) => {
  const url = `${assessmentService}/assessment/taxingunitexemption/${taxingUnitExemptionID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchVersionTaxRates = async (
  { assessmentService },
  authenticationToken,
  { versionID },
) => {
  const url = `${assessmentService}/assessment/taxingunit/version/${versionID}/taxrates`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateVersionTaxRate = async (
  { assessmentService },
  authenticationToken,
  { versionID, payload },
) => {
  const url = `${assessmentService}/assessment/taxingunit/version/${versionID}/taxrates`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};
